import React, { useState, useEffect, useRef, Fragment } from "react";
import Select from "react-select";
import _ from "lodash";
import classnames from "classnames";
import moment from "moment";
import CircularProgress from "@material-ui/core/CircularProgress";
import Fade from "@material-ui/core/Fade";
import Firebase from "../../../firebasehelper";
import { default_article } from "../constants/default";
import { topicTypes, layerTypes } from "../constants/selections";
import FullImageUpload from "../../../components/ContentUpload/FullImageUpload";
import ImageUpload from "../../../components/ContentUpload/ImageUpload";
import VideoUpload from "../../../components/ContentUpload/VideoUpload";
import YoutubeInput from "../../../components/ContentUpload/YoutubeInput";
import DateTimePicker from "../../../components/DateTimePicker";
import TimePicker from "../../../components/TimePicker";
import RadioItem from "../../../components/RadioItem";
import {
  YOUTUBE_URL,
  IMAGE_UPLOAD,
  VIDEO_UPLOAD,
  GIF_UPLOAD,
} from "../../../Constants/types";
import {
  UPLOADING_VIDEO,
  UPLOADING_IMAGE,
  UPLOADING_GIF,
} from "../../../Constants/string";
import "./ArticleForm.css";
import { idealTextColor, isDeepEqual, regexForHTML } from "../../../functions";
import MediaUpload from "../../../components/ContentUpload/MediaUpload";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const remove_icon = require("../../../assets/media/stop.png");

const manualStyle = {
  control: (base) => ({
    ...base,
    borderWidth: 4,
    borderColor: "#d5fec6",
    "&:hover": {
      borderColor: "#d5fec6",
    },
    // This line disable the blue border
    boxShadow: "none",
  }),
};
const defaultStyle = {
  control: (base) => ({
    ...base,
  }),
};

const quillModules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link", "image"],
    ["clean"],
  ],
};

const quillFormats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
];

const ArticleForm = ({
  onChangeArticle,
  events,
  products,
  liveTasks,
  article = default_article,
  updateArticle,
  hex,
  white,
  handleLoading,
  isPublic,
  toReferrals,
  toMembers,
  setToMembers,
  setToReferrals,
  setIsPublic,
}) => {
  // const [article, updateArticle] = useState(default_article);
  const [tags, setTags] = useState([]);
  const [types, setTypes] = useState(topicTypes);
  const [loading, setLoading] = useState(false);
  const [loading_script, setLoadingScript] = useState("");
  const [selectStyle, setSelectStyle] = useState(defaultStyle);
  const [selectedDate, setSelectedDate] = useState();
  const [leadMediaDimension, setLeadMediaDimension] = useState({
    width: 0,
    height: 0,
  });
  const [leadMediaMobileDimension, setLeadMediaMobileDimension] = useState({
    width: 0,
    height: 0,
  });
  const [value, setValue] = useState("");
  const reactQuillRef = useRef([]);
  // useEffect(() => {
  //   if(!isDeepEqual(article, default_article)) {
  //     onChangeArticle(article);
  //   }
  // }, [article]);

  useEffect(() => {
    if (article) {
      if (article.layers) {
        const newLayers = article.layers.map((layer) => {
          if (["paragraph", "standout paragraph"].includes(layer.type)) {
            if (!regexForHTML.test(layer.data)) {
              layer.data = `<p>${layer.data}</p>`;
            }
          }
          return layer;
        });
        article.layers = newLayers;
        updateArticle(article);
      }
      setToMembers(article.toMembers === undefined ? true : article.toMembers);
      setToReferrals(
        article.toReferrals === undefined ? true : article.toReferrals
      );
    }
  }, []);
  useEffect(() => {
    reactQuillRef.current = reactQuillRef.current.slice(
      0,
      article.layers.length
    );
  }, [article.layers]);
  useEffect(() => {
    const total_tags = [];
    total_tags["event"] = events;
    total_tags["product"] = products;
    setTags(total_tags);
  }, [events, products]);

  useEffect(() => {
    handleLoading(loading);
  }, [loading]);

  const getOptions = (type) => {
    if (type === "event")
      return [{ label: "No Tag", value: null }].concat(
        tags[type].map((tag) => ({
          value: tag,
          label: tag.title,
        }))
      );
    if (type === "product")
      return [{ label: "No Tag", value: null }].concat(
        tags[type].map((tag) => ({
          value: tag,
          label: tag.caption,
        }))
      );
  };

  const getValue = (data, type) => {
    if (type === "event") return data.title;
    if (type === "product") return data.caption;
  };
  const liveTasksArrayOptions = liveTasks
    ? liveTasks.map((task) => ({
        value: task,
        label: task.title,
      }))
    : [{ label: "N/A", value: null }];
  /*  start of handlers */
  const handleInputChange = ({ target }) => {
    const { name, value } = target;
    const newArticle = _.cloneDeep(article);
    newArticle[name] = value;
    updateArticle(newArticle);
  };

  const handleChangeMembersAccess = (value) => {
    const newArticle = _.cloneDeep(article);
    newArticle.toMembers = value;
    updateArticle(newArticle);
  };

  const handleChangeIsPublic = (value) => {
    const newArticle = _.cloneDeep(article);
    newArticle.isPublic = value;
    updateArticle(newArticle);
  };

  const handleChangeReferralsAccess = (value) => {
    const newArticle = _.cloneDeep(article);
    newArticle.toReferrals = value;
    updateArticle(newArticle);
  };

  const handleSelectTopic = (value) => {
    const newArticle = _.cloneDeep(article);
    newArticle["topic"] = value.value;
    updateArticle(newArticle);
    if (topicTypes.find((item) => item === value.value))
      setSelectStyle(defaultStyle);
    else setSelectStyle(manualStyle);
  };

  const handleChangeLeadMedia = (media_url) => {
    updateArticle((article) => {
      const newArticle = _.cloneDeep(article);
      newArticle["leadMedia"] = media_url;
      console.log("new article:", newArticle);
      return newArticle;
    });
  };

  const handleChangeLeadMediaMobile = (media_url) => {
    updateArticle((article) => {
      const newArticle = _.cloneDeep(article);
      newArticle["leadMediaMobile"] = media_url;
      console.log("new article:", newArticle);
      return newArticle;
    });
  };

  const handleLayerChange = (index, key, value) => {
    const newArticle = _.cloneDeep(article);
    newArticle["layers"][index][key] = value;
    if (!isDeepEqual(article, newArticle)) {
      updateArticle(newArticle);
    }
  };

  const handlePictureParagraphChange = (index, key, value) => {
    const newArticle = _.cloneDeep(article);
    newArticle["layers"][index][key] = value;
    updateArticle(newArticle);
  };

  const handleUploadProgress = (snapshot) => {
    var progress = (
      (snapshot.bytesTransferred / snapshot.totalBytes) *
      100
    ).toFixed(0);
    const loading_script = UPLOADING_VIDEO + " " + progress + "%";
    setLoadingScript(loading_script);
  };

  const handleUploadError = (error) => {
    setLoadingScript("");
    setLoading(false);
  };

  const handleAnswerChange = (index, answer_index, value) => {
    const newArticle = _.cloneDeep(article);
    newArticle["layers"][index].answers[answer_index] = value;
    updateArticle(newArticle);
  };

  const handleInputTopicChange = (inputValue, action) => {
    if (action.action !== "input-blur" && action.action !== "menu-close") {
      if (!topicTypes.find((item) => item === inputValue)) {
        let newTypes = [...topicTypes];
        newTypes.push(inputValue);
        setTypes(newTypes);
        setSelectStyle(manualStyle);
      } else setSelectStyle(defaultStyle);
    }
  };
  /* end of handlers */

  const addNewLayer = () => {
    const newArticle = _.cloneDeep(article);
    newArticle["layers"].push({ type: "", data: "" });
    updateArticle(newArticle);
  };

  const uploadLeadMedia = async (mediaContent, title) => {
    let uploadFolder = "articles";
    setLoading(true);
    setLoadingScript(UPLOADING_IMAGE);
    let img_url = await Firebase.uploadImg(
      mediaContent,
      title,
      uploadFolder + "/images"
    );
    setLoading(false);
    handleChangeLeadMedia(img_url);
  };

  const uploadLeadMediaMobile = async (mediaContent, title) => {
    let uploadFolder = "articles";
    setLoading(true);
    setLoadingScript(UPLOADING_IMAGE);
    let img_url = await Firebase.uploadImg(
      mediaContent,
      title,
      uploadFolder + "/images"
    );
    setLoading(false);
    handleChangeLeadMediaMobile(img_url);
  };

  const removeAnswer = (index, answer_index) => {
    const newArticle = _.cloneDeep(article);
    newArticle["layers"][index].answers.splice(answer_index, 1);
    updateArticle(newArticle);
  };
  const addAnswer = (index) => {
    const newArticle = _.cloneDeep(article);
    if (!newArticle["layers"][index].answers)
      newArticle["layers"][index].answers = [""];
    else newArticle["layers"][index].answers.push("");
    updateArticle(newArticle);
  };
  const uploadContent = async (
    contentType,
    mediaContent,
    layerIndex,
    title
  ) => {
    let uploadFolder = "articles";
    if (contentType === GIF_UPLOAD) {
      setLoading(true);
      setLoadingScript(UPLOADING_GIF);
      let gif_url = await Firebase.uploadGif(
        mediaContent,
        title,
        uploadFolder + "/gifs"
      );
      handleLayerChange(layerIndex, "media_url", gif_url);
      setLoading(false);
    } else if (contentType === IMAGE_UPLOAD) {
      setLoading(true);
      setLoadingScript(UPLOADING_IMAGE);
      let img_url = await Firebase.uploadImage(
        mediaContent,
        title,
        uploadFolder + "/images"
      );
      handleLayerChange(layerIndex, "media_url", img_url);
      setLoading(false);
    } else if (contentType === VIDEO_UPLOAD) {
      const uploadTask = Firebase.uploadVideo(
        mediaContent,
        uploadFolder + "/videos"
      );
      setLoading(true);
      setLoadingScript(UPLOADING_VIDEO);
      uploadTask.on(
        "state_changed",
        handleUploadProgress,
        handleUploadError,
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            handleLayerChange(layerIndex, "media_url", downloadURL);
            setLoading(false);
            setLoadingScript("");
          });
        }
      );
    } else if (contentType === YOUTUBE_URL) {
      handleLayerChange(layerIndex, "media_url", mediaContent);
    }
  };

  const uploadPictureParagraph = async (
    contentType,
    mediaContent,
    layerIndex,
    title
  ) => {
    let uploadFolder = "articles";
    if (contentType === GIF_UPLOAD) {
      setLoading(true);
      setLoadingScript(UPLOADING_GIF);
      let gif_url = await Firebase.uploadGif(
        mediaContent,
        title,
        uploadFolder + "/gifs"
      );
      handlePictureParagraphChange(layerIndex, "media", {
        media_url: gif_url,
        media_type: GIF_UPLOAD,
      });
      setLoading(false);
    } else if (contentType === IMAGE_UPLOAD) {
      setLoading(true);
      setLoadingScript(UPLOADING_IMAGE);
      let img_url = await Firebase.uploadImage(
        mediaContent,
        title,
        uploadFolder + "/images"
      );
      handlePictureParagraphChange(layerIndex, "media", {
        media_url: img_url,
        media_type: IMAGE_UPLOAD,
      });
      setLoading(false);
    } else if (contentType === VIDEO_UPLOAD) {
      const uploadTask = Firebase.uploadVideo(
        mediaContent,
        uploadFolder + "/videos"
      );
      setLoading(true);
      setLoadingScript(UPLOADING_VIDEO);
      uploadTask.on(
        "state_changed",
        handleUploadProgress,
        handleUploadError,
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            handlePictureParagraphChange(layerIndex, "media", {
              media_url: downloadURL,
              media_type: VIDEO_UPLOAD,
            });
            setLoading(false);
            setLoadingScript("");
          });
        }
      );
    }
  };

  const removeLayer = (index) => {
    const newArticle = _.cloneDeep(article);
    newArticle.layers.splice(index, 1);
    updateArticle(newArticle);
  };

  const checkCharacterCount = (event, index) => {
    const unprivilegedEditor = reactQuillRef.current[index].unprivilegedEditor;
    if (unprivilegedEditor.getLength() > 500 && event.key !== "Backspace") {
      event.preventDefault();
    }
  };

  const handlePostNowChanged = (value) => {
    const newArticle = _.cloneDeep(article);
    newArticle.postNow = value;
    updateArticle(newArticle);
  };

  const handleSchedule = (value) => {
    const newArticle = _.cloneDeep(article);
    newArticle.scheduledDate = value.valueOf();
    updateArticle(newArticle);
  };

  const handleChangeTime = (obj) => {
    const { hh, mm, of } = obj;
    let hours = hh;
    let newMoment = moment(selectedDate);
    if (of === "pm" && hh !== 12) hours = hh + 12;
    newMoment.set("hour", hours);
    newMoment.set("minute", mm);
    const newArticle = _.cloneDeep(article);

    if (newMoment.isBefore(moment())) {
      newArticle.postNow = true;
    } else newArticle.postNow = false;
    newArticle.scheduledDate = newMoment.valueOf();
    console.log(
      "🚀 ~ file: ArticleForm.js:474 ~ handleChangeTime ~ newArticle:",
      newArticle
    );
    updateArticle(newArticle);
  };

  return (
    <div className={`mt-3`} style={{ textAlign: "left", width: "100%" }}>
      <React.Fragment>
        <h5 className="section-title">Title</h5>
        <input
          name="title"
          className="form-control form-control-md mb-4"
          value={article.title}
          onChange={handleInputChange}
          placeholder="Title"
          autoComplete="off"
        />
      </React.Fragment>
      {/* <h5 className="section-title">Topic</h5>
      <div className="mb-2">
        <Select
          isSearchable={true}
          name="topic"
          value={
            article.topic
              ? { value: article.topic, label: article.topic }
              : null
          }
          styles={selectStyle}
          onChange={handleSelectTopic}
          options={types.map((obj) => ({
            value: obj,
            label: obj,
          }))}
          placeholder="Select a topic"
          onInputChange={handleInputTopicChange}
          noOptionsMessage={() => "..."}
        />
      </div> */}
      <div className="landscape-media-container">
        <div className="landscape-media-content">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ width: "60%" }}>
              <h5 className="section-title">
                Lead Media (Landscape optimised)
              </h5>
              {article && (
                <p className="small-text">
                  Image is already setup for lead media (landscape optimised).
                  You can change by choosing another image.
                </p>
              )}
            </div>
            <div>
              <p className="section-title">Landscape dimensions guide</p>
              <p className="small-text">height: 356 px x width: 1650 px</p>
            </div>
          </div>
          <FullImageUpload
            onChangeContent={(content) =>
              uploadLeadMedia(content, article.title)
            }
            currentImage={article.leadMedia}
            hex={hex}
            setDimension={setLeadMediaDimension}
          />
        </div>
        {/* <div className="landscape-media-dimension">
          <img
            src={article.leadMedia}
            alt=""
            id="landscape-img"
            style={{ display: "none" }}
          />
          <p className="section-title">Landscape dimensions guide</p>
          <p className="small-text">height: 356 px x width: 1650 px</p>
        </div> */}
      </div>
      <div className="landscape-media-container">
        <div className="landscape-media-content">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ width: "60%" }}>
              <h5 className="section-title">Lead Media (Mobile optimised)</h5>
              {article && (
                <p className="small-text">
                  Image is already setup for lead media (mobile optimised). You
                  can change by choosing another image.
                </p>
              )}
            </div>
            <div>
              <p className="section-title">Mobile dimensions guide</p>
              <p className="small-text">height: 525 px x width: 525 px</p>
            </div>
          </div>
          <FullImageUpload
            onChangeContent={(content) =>
              uploadLeadMediaMobile(content, article.title)
            }
            currentImage={article.leadMediaMobile}
            hex={hex}
            setDimension={setLeadMediaMobileDimension}
          />
        </div>
        {/* <div className="landscape-media-dimension">
          <img
            src={article.leadMedia}
            alt=""
            id="landscape-img"
            style={{ display: "none" }}
          />
          <p className="section-title">Mobile dimensions guide</p>
          <p className="small-text">height: 525 px x width: 525 px</p>
        </div> */}
      </div>
      <React.Fragment>
        <h5 className="section-title">Lead Paragraph</h5>
        <textarea
          name="leadParagraph"
          className="form-control form-control-md mb-2"
          placeholder="Input lead paragraph..."
          onChange={handleInputChange}
          value={article.leadParagraph}
          maxLength="500"
        />
        <p className="bottom-small-text">Max characters: 500</p>
      </React.Fragment>
      <React.Fragment>
        {article.layers &&
          article.layers.map((layer, index) => (
            <React.Fragment key={index}>
              <div className="section-title">
                <h5>New layer</h5>
                <img
                  src={remove_icon}
                  alt=""
                  className="remove-layer-icon"
                  onClick={() => removeLayer(index)}
                />
                <p>{index + 1}</p>
              </div>
              <div className="mb-2">
                <Select
                  value={
                    article.layers[index].type
                      ? {
                          label: _.capitalize(article.layers[index].type),
                          value: article.layers[index].type,
                        }
                      : null
                  }
                  onChange={(value) =>
                    handleLayerChange(index, "type", value.value)
                  }
                  placeholder="Select a layer type"
                  options={layerTypes}
                />
              </div>
              {article.layers[index].type && (
                <div className="mb-2">
                  {["subtitle", "agreeableness", "question"].includes(
                    article.layers[index].type
                  ) && (
                    <input
                      name={article.layers[index].type}
                      placeholder={`Input ${article.layers[index].type}...`}
                      className="form-control form-control-md mb-4"
                      value={article.layers[index].data}
                      onChange={({ target }) =>
                        handleLayerChange(index, "data", target.value)
                      }
                      autoComplete="off"
                    />
                  )}
                  {["paragraph", "standout paragraph"].includes(
                    article.layers[index].type
                  ) && (
                    <React.Fragment>
                      <ReactQuill
                        theme="snow"
                        onKeyDown={(e) => checkCharacterCount(e, index)}
                        ref={(el) => (reactQuillRef.current[index] = el)}
                        defaultValue={layer.data}
                        onChange={(content, delta, source, editor) => {
                          handleLayerChange(index, "data", content);
                        }}
                        modules={quillModules}
                        formats={quillFormats}
                        key={index}
                      />
                      <p className="bottom-small-text">Max characters: 500</p>
                    </React.Fragment>
                  )}
                  {article.layers[index].type === "quote" && (
                    <React.Fragment>
                      <textarea
                        name={article.layers[index].type}
                        className="form-control form-control-md mb-2"
                        placeholder={`Input ${article.layers[index].type}...`}
                        onChange={({ target }) =>
                          handleLayerChange(index, "data", target.value)
                        }
                        value={article.layers[index].data}
                        maxLength="500"
                      />
                      <p className="bottom-small-text">Max characters: 500</p>
                    </React.Fragment>
                  )}
                  {["event", "product"].includes(
                    article.layers[index].type
                  ) && (
                    <div className="mb-2">
                      <Select
                        value={
                          article.layers[index].data
                            ? {
                                label: getValue(
                                  article.layers[index].data,
                                  article.layers[index].type
                                ),
                                value: article.layers[index].data,
                              }
                            : null
                        }
                        onChange={(value) =>
                          handleLayerChange(index, "data", value.value)
                        }
                        placeholder={`Tag ${article.layers[index].type}`}
                        options={getOptions(article.layers[index].type)}
                      />
                    </div>
                  )}
                  {article.layers[index].type === "token earning task" && (
                    <div className="mb-2">
                      <Select
                        value={
                          article.layers[index].data
                            ? {
                                label: article.layers[index].data.title,
                                value: article.layers[index].data,
                              }
                            : null
                        }
                        onChange={(value) =>
                          handleLayerChange(index, "data", value.value)
                        }
                        placeholder="Select Token Earning Task"
                        options={liveTasksArrayOptions}
                      />
                    </div>
                  )}
                  {article.layers[index].type === "picture and paragraph" && (
                    <React.Fragment>
                      <textarea
                        name={article.layers[index].type}
                        className="form-control form-control-md mb-2"
                        placeholder={`Input ${article.layers[index].type}...`}
                        onChange={({ target }) =>
                          handlePictureParagraphChange(
                            index,
                            "data",
                            target.value
                          )
                        }
                        value={article.layers[index].data}
                        maxLength="220"
                      />
                      <p className="bottom-small-text">Max characters: 220</p>
                      <MediaUpload
                        onChangeContent={(content, mediaType) =>
                          uploadPictureParagraph(
                            mediaType,
                            content,
                            index,
                            article.layers[index].data
                          )
                        }
                        contentUrl={
                          article.layers[index].media
                            ? article.layers[index].media.media_url
                            : ""
                        }
                        contentType={
                          article.layers[index].media
                            ? article.layers[index].media.media_type
                            : ""
                        }
                      />
                    </React.Fragment>
                  )}
                  {article.layers[index].type === "poll" && (
                    <React.Fragment>
                      <input
                        name={article.layers[index].type}
                        placeholder="Poll Question"
                        className="form-control form-control-md mb-2"
                        value={article.layers[index].data}
                        onChange={({ target }) =>
                          handleLayerChange(index, "data", target.value)
                        }
                        autoComplete="off"
                      />
                      {article.layers[index].answers &&
                        article.layers[index].answers.map(
                          (answer, answer_index) => (
                            <div className="polls-answer" key={answer_index}>
                              <input
                                placeholder="Answer"
                                className="form-control form-control-md mt-2 mb-2"
                                value={
                                  article.layers[index].answers
                                    ? article.layers[index].answers[
                                        answer_index
                                      ]
                                    : ""
                                }
                                onChange={({ target }) =>
                                  handleAnswerChange(
                                    index,
                                    answer_index,
                                    target.value
                                  )
                                }
                                autoComplete="off"
                              />
                              <button
                                onClick={() =>
                                  removeAnswer(index, answer_index)
                                }
                              >
                                <i class="fas fa-trash-alt"></i>
                              </button>
                            </div>
                          )
                        )}
                      {console.log("white", white)}
                      <button
                        className={`btn btn-brand-hex btn-white mr-1`}
                        type="button"
                        onClick={() => addAnswer(index)}
                        style={{
                          backgroundColor: "white",
                          color: "black",
                          "--hover-color": hex,
                          "--hover-text-color": white ? "white" : "black",
                        }}
                      >
                        Add new answer
                      </button>
                    </React.Fragment>
                  )}
                  {article.layers[index].type === IMAGE_UPLOAD && (
                    <ImageUpload
                      onChangeContent={(content) =>
                        uploadContent(
                          article.layers[index].type,
                          content,
                          index,
                          article.layers[index].data
                        )
                      }
                      contentUrl={article.layers[index].media_url || ""}
                    />
                  )}
                  {article.layers[index].type === GIF_UPLOAD && (
                    <ImageUpload
                      isGif={true}
                      onChangeContent={(content) =>
                        uploadContent(
                          article.layers[index].type,
                          content,
                          index,
                          article.layers[index].data
                        )
                      }
                      contentUrl={article.layers[index].media_url || ""}
                    />
                  )}
                  {article.layers[index].type === VIDEO_UPLOAD && (
                    <VideoUpload
                      onChangeContent={(content) =>
                        uploadContent(
                          article.layers[index].type,
                          content,
                          index,
                          article.layers[index].data
                        )
                      }
                      defaultVideo={article.layers[index].media_url || ""}
                    />
                  )}
                  {article.layers[index].type === YOUTUBE_URL && (
                    <YoutubeInput
                      onChangeContent={(content) =>
                        uploadContent(
                          article.layers[index].type,
                          content,
                          index,
                          article.layers[index].data
                        )
                      }
                    />
                  )}
                </div>
              )}
            </React.Fragment>
          ))}
      </React.Fragment>
      <Fade
        in={loading}
        style={{
          transitionDelay: loading ? "800ms" : "0ms",
        }}
        unmountOnExit
      >
        <Fragment>
          <p>{loading_script}</p>
          <CircularProgress />
        </Fragment>
      </Fade>
      {!loading && (
        <button
          className={`btn btn-brand-hex btn-white`}
          type="button"
          onClick={addNewLayer}
          style={{
            color: white ? "white" : "black",
            backgroundColor: hex,
            "--hover-color": "white",
            "--hover-text-color": "black",
          }}
        >
          Add new layer
        </button>
      )}

      <p className="article-schedule-title">
        {!article.selectedDate && (
          <React.Fragment>
            <b>Post now</b> or{" "}
          </React.Fragment>
        )}
        <b>Schedule</b>
      </p>
      {!article.selectedDate && (
        <div className="article-schdule-now-container">
          <div
            className={classnames("check-box", {
              checked: article.postNow,
            })}
            onClick={() => handlePostNowChanged(true)}
            style={{
              marginLeft: "20px",
            }}
          ></div>
          <div
            className={classnames("check-box", {
              checked: !article.postNow,
            })}
            onClick={() => handlePostNowChanged(false)}
            style={{
              marginLeft: "80px",
            }}
          ></div>
        </div>
      )}
      {!article.postNow && !article.selectedDate && (
        <DateTimePicker onTimeChange={handleSchedule} />
      )}
      {selectedDate && (
        <React.Fragment>
          <p className="article-schedule-time">{selectedDate.format("LLL")}</p>
          <TimePicker onChange={handleChangeTime} />
        </React.Fragment>
      )}

      <div className="user-access-categories">
        <p>Post to user access categories</p>
        <RadioItem
          menuName="Members"
          checked={toMembers}
          onYes={() => {
            setToMembers(true);
            handleChangeMembersAccess(true);
          }}
          onNo={() => {
            setToMembers(false);
            handleChangeMembersAccess(false);
          }}
        />
        <RadioItem
          menuName="Prospect"
          checked={toReferrals}
          onYes={() => {
            setToReferrals(true);
            handleChangeReferralsAccess(true);
          }}
          onNo={() => {
            setToReferrals(false);
            handleChangeReferralsAccess(false);
          }}
        />
      </div>
      <div className="privacy-categories">
        <p>Content platform privacy</p>
        <RadioItem
          menuName="Public"
          checked={isPublic}
          onYes={() => {
            setIsPublic(true);
            handleChangeIsPublic(true);
          }}
          onNo={() => {
            setIsPublic(false);
            handleChangeIsPublic(false);
          }}
        />
      </div>
    </div>
  );
};

export default ArticleForm;



// WEBPACK FOOTER //
// ./src/screens/Articles/components/ArticleForm.js